angular.module('myApp.services')
    .factory("user", function() {
        var data = {
            'userId' : null
        };

        return {
            setUserData: function(userData) {
                if ('userId' in userData) {
                    data = userData;
                }
            },
            getUserId: function() {
                return data.userId;
            }
        }
    });